import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Blog from "./pages/Blog";
import ProjectTrackingBlog from "./pages/ProjectTrackingBlog";
import AdminWaitlist from "./pages/AdminWaitlist";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import DataProtection from "./pages/DataProtection";
import ReferralTerms from "./pages/ReferralTerms";
import Disclaimer from "./pages/Disclaimer";
import Sitemap from "./pages/Sitemap";
import HowItWorksPage from "./pages/HowItWorksPage";
import MarketplacePage from "./pages/MarketplacePage";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import HttpsRedirect from "@/components/HttpsRedirect";

const queryClient = new QueryClient();

const App = () => (
  <>
    <HttpsRedirect />
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/project-tracking-zimbabwe" element={<ProjectTrackingBlog />} />
              <Route 
                path="/admin/waitlist" 
                element={
                  <ProtectedRoute>
                    <AdminWaitlist />
                  </ProtectedRoute>
                } 
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/tos" element={<TermsOfService />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/security" element={<DataProtection />} />
              <Route path="/referral-terms" element={<ReferralTerms />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/sitemap.xml" element={<Sitemap />} />
              {/* SEO-friendly routes */}
              <Route path="/diaspora-projects" element={<Index />} />
              <Route path="/track-my-builder" element={<Index />} />
              <Route path="/verified-zimbabwe-suppliers" element={<MarketplacePage />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </>
);

export default App;
